import * as THREE from 'three/webgpu';
import {LINE_DISTANCE_PERCENT_ATTRIBUTE_NAME} from './ThinChainLineNodeMaterial';
import {isDashDotLIneNodeMaterial} from './guards/isDashDotLIneNodeMaterial';
import {createLineDistancePercentages} from './utils/createLineDistancePercentages';


/**
 * 从位置 attribute 提取细点画线点列。
 * @param positionAttribute 位置 attribute。
 * @returns 细点画线点列。
 */
function createThinChainLinePointsFromPositionAttribute(
    positionAttribute: THREE.BufferAttribute | THREE.InterleavedBufferAttribute,
): THREE.Vector3[] {
    const points: THREE.Vector3[] = [];

    for (let index = 0; index < positionAttribute.count; index += 1) {
        points.push(new THREE.Vector3().fromBufferAttribute(positionAttribute, index));
    }

    return points;
}

/**
 * 同步细点画线材质依赖的几何数据。
 * 说明：
 * 1. `ThinChainLIneNodeMaterial` 依赖屏幕空间距离百分比控制点画节奏；
 * 2. 每条预览线持有独立材质实例，更新几何后必须同步材质点列；
 * 3. 该工具集中复用预览线和草图线共同需要的几何同步逻辑，避免各处理器重复实现。
 * @param line 待同步的线对象。
 */
export function syncThinChainLineGeometry(line: THREE.Line): void {
    line.computeLineDistances();

    const positionAttribute = line.geometry.getAttribute('position');
    const lineDistanceAttribute = line.geometry.getAttribute('lineDistance');
    if (!lineDistanceAttribute) {
        line.geometry.deleteAttribute(LINE_DISTANCE_PERCENT_ATTRIBUTE_NAME);
        return;
    }

    line.geometry.setAttribute(
        LINE_DISTANCE_PERCENT_ATTRIBUTE_NAME,
        new THREE.Float32BufferAttribute(
            createLineDistancePercentages(lineDistanceAttribute),
            1,
        ),
    );

    const targetMaterial = Array.isArray(line.material)
        ? line.material[0]
        : line.material;
    if (positionAttribute && isDashDotLIneNodeMaterial(targetMaterial)) {
        targetMaterial.points = createThinChainLinePointsFromPositionAttribute(positionAttribute);
    }
}

